import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { Grid } from "@material-ui/core";
import isMobile from "~/hooks/isMobile";
import { formatNumberToBRL } from "~/utils/tools";
import { useSelector } from "react-redux";
import { groupBy, orderBy } from "lodash";

import {
  Modal,
  Margin,
  Input,
  Select,
  Button,
} from "~/components/elements";
import * as S from "./styles";

import { schema } from "./validation";

export default function ProductsModal({
  handleModalProduct,
  addProduct,
  modalData,
}) {
  const mobile = isMobile();
  const [products, setProducts] = useState([]);

  const allProducts = useSelector(
    (state) => state.promo.listProducts.response.produtos
  );

  const brands = Object.keys(groupBy(allProducts, "Marca"))?.map((data) => {
    return { value: data, label: data };
  });

  const brandsAsc = orderBy(brands, ["value"], ["asc"]);

  const selectedBrand = brandsAsc.find(
    (data) => data.value === modalData?.Marca?.value
  );

  const getProductsByBrand = ({ value }) => {
    const filteredProduct = allProducts.filter((data) => data.Marca === value);
    const parseFilteredProducts = filteredProduct?.map(
      ({ Id, Nome, Imagem }) => {
        return {
          id: Id,
          value: Id,
          label: Nome,
          imagem: Imagem,
        };
      }
    );
    if (parseFilteredProducts) setProducts(parseFilteredProducts);
  };

  const selectedProduct = products.find(
    (data) => data.id === modalData?.Produto?.id
  );

  useEffect(() => {
    if (modalData?.Produto?.id)
      getProductsByBrand({ value: modalData?.Marca?.label });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalData]);

  const initialValues = {
    Produto: selectedProduct || "",
    Quantidade: modalData?.Quantidade || 1,
    Valor: modalData?.Valor ? formatNumberToBRL(modalData.Valor) : "",
    Marca: selectedBrand || "",
  };

  return (
    <Modal
      open={modalData?.open}
      mobile={mobile}
      closeModal={() => {
        setProducts([]);
        handleModalProduct(false);
      }}
    >
      <S.ModalContent>
        <Margin mb={mobile ? 2 : 4}>
          <S.Title>
            <strong>Insira os produtos do seu cupom fiscal</strong>
          </S.Title>
        </Margin>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitting(false);
            addProduct({
              ...values,
              name: values.Produto.label,
              key: modalData?.key?.toString(),
            });
            resetForm();
            setProducts([]);
            handleModalProduct({ open: false, key: modalData?.key?.toString() });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container>
                <Grid item xs={12} md={12}>
                  <Margin mb={4}>
                    <Select
                      label="Selecionar a marca:"
                      name="Marca"
                      placeholder="Selecione a marca"
                      disabled={modalData?.Produto?.id}
                      onChange={(name, value) => {
                        setFieldValue(name, value);
                        setFieldValue("Produto", initialValues.Produto);
                        getProductsByBrand(value);
                      }}
                      onBlur={handleBlur}
                      value={values.Marca}
                      errors={errors.Marca && touched.Marca && errors.Marca}
                      options={brandsAsc || []}
                      id="selectBrand"
                    />
                  </Margin>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Margin mb={4}>
                    <Select
                      label="Selecionar produto:"
                      name="Produto"
                      disabled={modalData?.Produto?.id}
                      placeholder="Selecione o produto"
                      onChange={setFieldValue}
                      onBlur={handleBlur}
                      value={values.Produto}
                      errors={errors.Produto && touched.Produto && errors.Produto}
                      options={products || []}
                      id="selectProduts"
                    />
                  </Margin>
                </Grid>

                <Grid item xs={6} md={6}>
                  <Margin mb={2} mr={2}>
                    <Input
                      label="Quantidade"
                      placeholder="1"
                      htmlFor="quantityFieldFormProducts"
                      name="Quantidade"
                      type="numberMaxLength"
                      min={1}
                      max={500}
                      maxLength="3"
                      value={values?.Quantidade}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={
                        errors.Quantidade &&
                        touched.Quantidade &&
                        errors.Quantidade
                      }
                      valid={
                        !errors.Quantidade &&
                        touched.Quantidade &&
                        !errors.Quantidade
                      }
                    />
                  </Margin>
                </Grid>
                <Grid item xs={6} md={6}>
                  <Margin mb={2}>
                    <Input
                      label="Valor unitário"
                      placeholder="R$"
                      htmlFor="priceFieldFormProducts"
                      name="Valor"
                      value={values.Valor}
                      onChange={(event) => {
                        const value = event.target.value.length;
                        if (value > 9) return;
                        const currency = formatNumberToBRL(event.target.value);
                        setFieldValue("Valor", currency);
                      }}
                      onBlur={handleBlur}
                      errors={errors.Valor && touched.Valor && errors.Valor}
                      valid={!errors.Valor && touched.Valor && !errors.Valor}
                    />
                  </Margin>
                </Grid>
                <S.BtnHolder>
                  <Button
                    className="animation-size"
                    id="addProductButtonFormProducts"
                    type="submit"
                  >
                    ADICIONAR PRODUTO
                  </Button>
                </S.BtnHolder>
              </Grid>
            </form>
          )}
        </Formik>
      </S.ModalContent>
    </Modal>
  );
}
